<div class="mt-4 bg-primary-200">
  <div
    class="flex flex-row items-center justify-between p-4 transition-colors duration-150 cursor-pointer select-none hover:bg-primary-300"
    [class.shadow-lg]="expanded"
    mat-ripple
    (click)="toggleExpanded()"
  >
    <div class="text-xs font-semibold text-primary-700">FAKTURY DO OPŁACENIA ({{ balance.items.length }})</div>

    <mat-icon class="text-primary-700 icon-20">{{ expanded ? 'expand_less' : 'expand_more' }}</mat-icon>
  </div>

  <div
    *ngIf="expanded"
    @drawerExpand
    class="px-4 py-3 space-y-3 overflow-y-scroll text-sm bg-primary-100 md:space-y-1 balance-items"
  >
    <div *ngFor="let item of balance.items; let i = index" class="flex flex-col">
      <div class="flex flex-row md:text-xs">
        <div class="mr-2">{{ i + 1 }}.</div>
        <div class="flex-grow min-h-0 md:truncate">{{ item.title }}</div>
        <div class="flex flex-col items-end flex-shrink-0 md:flex-row md:items-center">
          <div [class.text-red-600]="item.status === BalanceItemPaymentStatus.OVERDUE">
            {{ item.amount | currency: 'PLN':'symbol':'.2-2':'pl-PL' }}
          </div>
          <app-liability-info [liability]="item"></app-liability-info>
        </div>
      </div>
    </div>
  </div>
</div>
